import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appStickyContainer]',
  standalone: true,
})
export class StickyContainerDirective {
  @HostBinding('class') elementClass = 'sticky-container';
}
